import React, { useState } from "react";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";

const VoiceInput = () => {
  const [text, setText] = useState("");
  const [isListening, setIsListening] = useState(false);

  const handleVoiceInput = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    
    if (!SpeechRecognition) {
      alert("Your browser does not support Speech Recognition.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US"; // You can change it to "hi-IN" for Hindi
    recognition.continuous = false;
    recognition.interimResults = false;

    recognition.onstart = () => {
      setIsListening(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setText(transcript);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
      setIsListening(false);
    };

    recognition.start();
  };

  return (
    <div className="flex items-center border p-2 rounded-md w-80 my-[200px]">
      <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="border-none outline-none w-full p-2"
        placeholder="Speak something..."
      />
      <button onClick={handleVoiceInput} className="ml-2">
        {isListening ? (
          <FaMicrophoneSlash className="text-red-500 text-xl" />
        ) : (
          <FaMicrophone className="text-blue-500 text-xl" />
        )}
      </button>
    </div>
  );
};

export default VoiceInput;
